import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import HelpPage from './pages/HelpPage';
import FeedbackPage from './pages/FeedbackPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import KvkkPage from './pages/legal/KvkkPage';
import ConsentPage from './pages/legal/ConsentPage';
import AccountDeletionPage from './pages/AccountDeletionPage';

import { AdminAuthProvider } from './admin/context/AdminAuthContext';
import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import Users from './admin/pages/Users';
import Notes from './admin/pages/Notes';
import Matches from './admin/pages/Matches';
import Messages from './admin/pages/Messages';
import Notifications from './admin/pages/Notifications';
import CourseOptions from './admin/pages/CourseOptions';
import FavoriteInsights from './admin/pages/FavoriteInsights';
import Settings from './admin/pages/Settings';

function AdminRoutes() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="notes" element={<Notes />} />
          <Route path="matches" element={<Matches />} />
          <Route path="messages" element={<Messages />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="courses" element={<CourseOptions />} />
          <Route path="favorites" element={<FavoriteInsights />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public */}
        <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
        <Route path="/help" element={<><Header /><HelpPage /><Footer /></>} />
        <Route path="/feedback" element={<><Header /><FeedbackPage /><Footer /></>} />
        <Route path="/gizlilik-politikasi" element={<><Header /><PrivacyPolicyPage /><Footer /></>} />
        <Route path="/kvkk" element={<><Header /><KvkkPage /><Footer /></>} />
        <Route path="/acik-riza" element={<><Header /><ConsentPage /><Footer /></>} />
        <Route path="/hesap-silme" element={<><Header /><AccountDeletionPage /><Footer /></>} />

        {/* Admin */}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
